import { FC } from "react";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../LinkTypes";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { SuperAdminIcon } from "../../../../assets/icons/Icons";
import { useTranslation } from "react-i18next";
import { theme } from "../../../../theme";

const sidebarLinks = [
    { linkName: SidebarLinkTypes.superAdminInvoices, path: SidebarLinkPathTypes.superAdminInvoices },
    { linkName: SidebarLinkTypes.superAdminAnalysisFilesNewEmployees, path: SidebarLinkPathTypes.superAdminAnalysisFilesNewEmployees },
    { linkName: SidebarLinkTypes.superAdminAnalysisFilesBoughtVouchers, path: SidebarLinkPathTypes.superAdminAnalysisFilesBoughtVouchers },
    { linkName: SidebarLinkTypes.superAdminAnalysisFilesUpcomingBonusRewards, path: SidebarLinkPathTypes.superAdminAnalysisFilesUpcomingBonusRewards },
    { linkName: SidebarLinkTypes.superAdminAnalysisFilesDirectPayout, path: SidebarLinkPathTypes.superAdminAnalysisFilesDirectPayout },
    { linkName: SidebarLinkTypes.superAdminAnalysisFilesCompanyPension, path: SidebarLinkPathTypes.superAdminAnalysisFilesCompanyPension },
    { linkName: SidebarLinkTypes.superAdminActionModules, path: SidebarLinkPathTypes.superAdminActionModules },
];

export const SuperAdminComplexLink: FC<ComplexLinkProps> = ({ activePathname, collapsed, showText }) => {
    const { t } = useTranslation();

    return (
        <BaseComplexSidebarLink
            activePathname={activePathname}
            collapsed={collapsed}
            showText={showText}
            icon={<SuperAdminIcon color="white" />}
            label={t(SidebarLinkTypes.superAdmin)}
            links={sidebarLinks}
            sxPopover={{ "&:hover": { color: theme.palette.primary.main } }}
        />
    );
};
